export default "__VITE_ASSET__p1Pe7GjC__"